<template>
  <path pid="0" d="M12 3a10 10 0 1011 10.82 1 1 0 00-1.59-.88 6 6 0 01-8.46-8.33A1 1 0 0012 3zm.15 10.81a8 8 0 008.39 1.81A8 8 0 1110.25 5.48a8 8 0 001.93 8.36z"/>
</template>
